import React from 'react';
import {CardContent, Grid2, Paper} from "@mui/material";
import Typography from "@mui/material/Typography";
import {Trans, useTranslation} from "react-i18next";
import {useNavigate} from "react-router";
import CartManager from "../../../managers/cartManager/cartManager";
import CartItemContract from "../../../managers/cartManager/contracts/cartItemContract";
import "./ProductCard.css";
import IconButton from "@mui/material/IconButton";
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import {useProductPromo} from "../../../managers/productPromoManager/productPromoManager";
import {grey} from "@mui/material/colors";
import Box from "@mui/material/Box";
import SaleRibbon from "../saleRibbon/SaleRibbon";
import {logGAEvent} from "../../../firebaseConfig/firebaseConfig";

function ProductCard(props) {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const productPromo = useProductPromo(props.product.id);

    const openProduct = () => {
        navigate(`/products/${props.product.id}`);
    }

    const getProps = () => {
        const product = props.product || {};
        if (product.params) {
            const ciProps = {};

            product.params.forEach(param => {
                ciProps[param.key] = param.values[0];
            });

            return ciProps;
        }

        return {};
    }

    const addToCart = event => {
        logGAEvent('add_to_cart', props.product);
        CartManager.addItemToCart(
            new CartItemContract(props.product.id, 1, getProps()));
        event.stopPropagation();
    }

    const price = Number(props.product?.price || 0);
    return (props.product && <>
        {Object.keys(productPromo).length ? <SaleRibbon/> : ''}
        <CardContent sx={{width: "100%", height: "100%", padding: 0, cursor: 'pointer'}}
                     onClick={openProduct}>
            <Paper sx={{padding: "14px", height: "100%"}} elevation={2}>
                <Grid2 container flexDirection={'column'} sx={{height: '100%'}} flexWrap={'nowrap'}>
                    <Grid2 minHeight={120}
                           height={'100%'}
                           flexShrink={1}
                           display={'flex'}
                           alignItems={"center"}
                    >
                        <div style={{position: "absolute", top: 0, left: 0, right: 0, bottom: 0, zIndex: 100}}/>
                        {props.product?.images?.[0] ? <CardContent
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '100%',
                                width: '100%',
                                p: 0
                            }}>
                            <img key={props.product.images[0].thumbnail || props.product.images[0].src}
                                 alt={props.product.images[0].alt}
                                 style={{width: '100%', height: '100%', objectFit: 'contain'}}
                                 src={props.product.images[0].src}/>
                        </CardContent> : ''}
                    </Grid2>
                    <Grid2 container>
                        <Grid2 container flexDirection={"column"} flexGrow={1} size={9.5}>
                            <Grid2>
                                <Typography variant="h8"><Trans i18nKey={props.product?.name}/></Typography>
                            </Grid2>
                            <Grid2 container alignItems={"center"} justifyContent={"space-between"}>
                                <Grid2>

                                    {productPromo['1'] ? <Box display={"flex"}>
                                        <Typography variant="h8"  fontWeight={500} sx={{pr: 1}}>
                                            {(price * (1 - productPromo['1'])).toFixed(2)} Lei
                                        </Typography>
                                        <Typography variant="body1" sx={{
                                            fontWeight: 'medium',
                                            textDecoration: 'line-through',
                                            color: grey[400]
                                        }} textAlign={'right'}>
                                            {(price || 0).toFixed(2)} Lei
                                        </Typography></Box> :
                                        <Typography variant="h8" fontWeight={500}>
                                            {props.product?.price} Lei
                                        </Typography>}
                                </Grid2>
                            </Grid2>
                        </Grid2>
                        <Grid2 size={2.5}>
                            <IconButton color={"secondary"} onClick={addToCart} title={t('productPage.addToCart')}>
                                <AddShoppingCartIcon fontSize={"large"}/>
                            </IconButton>
                        </Grid2>
                    </Grid2>
                </Grid2>
            </Paper>
        </CardContent></>);
}

export default ProductCard;
